import logoMark from '../assets/logo/relate-ai-rainbow-spiral-logo-mark.jpg';

export default function Footer() {
  return (
    <footer id="about" className="border-t border-white/70 bg-white/55 py-8 backdrop-blur-xl">
      <div className="section-container flex flex-col items-center justify-between gap-5 text-center sm:flex-row sm:text-left">
        <a href="#top" className="flex items-center gap-3 font-extrabold" aria-label="Relate.ai home">
          <img src={logoMark} alt="" className="h-9 w-9 rounded-xl object-cover" />
          <span>Relate<span className="gradient-text">.ai</span></span>
        </a>
        <p className="max-w-2xl text-sm leading-6 text-slate-500">AI beyond chat. Intelligence that connects. Experimental adaptive intelligence for memory, communication, workflow, and action.</p>
        <p className="text-sm font-semibold text-slate-500">© 2026 Relate.ai</p>
      </div>
    </footer>
  );
}
